import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { DEFAULT_TIME } from "../../constants/input-entries-constants";

export const apiCallSendOneOTwoMessage = async ({
  alkhattabaUUID,
  clientUserID,
  clientUUID,
  matchUUID,
  matchID,
  alkhattabaText
}: {
  alkhattabaUUID: string;
  clientUserID: number;
  clientUUID: string;
  matchID: number;
  matchUUID: string;
  alkhattabaText: string;
}): Promise<{
  data: {
    currentTime: string;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    currentTime: string;
  }>(`khattabat/sendOneOTwoMsg`, {
    alkhattabaUUID,
    clientUserID,
    clientUUID,
    matchID,
    matchUUID,
    alkhattabaText
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        currentTime: DEFAULT_TIME
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        currentTime: DEFAULT_TIME
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
